import { render, staticRenderFns } from "./form-cheng-yuan.vue?vue&type=template&id=8be8b27e&scoped=true&"
import script from "./form-cheng-yuan.vue?vue&type=script&lang=js&"
export * from "./form-cheng-yuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be8b27e",
  null
  
)

export default component.exports